module.exports = __webpack_public_path__ + "img/102020.a914eca6.png";